// src/api.ts

import axios, { AxiosError } from 'axios';

// APIのベースURL（環境変数から取得）
const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;

// API呼び出しの共通関数
export const callApi = async (endpoint: string, data: any, token: string) => {
    try {
        const result = await axios.post(`${API_BASE_URL}${endpoint}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return result.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError;
            if (axiosError.response) {
                let errorMessage = `エラー: ${axiosError.response.status}`;
                if (axiosError.response.data) {
                    if (typeof axiosError.response.data === 'object') {
                        const errorData = axiosError.response.data as any;
                        if (errorData.error) {
                            errorMessage += ` - ${errorData.error}`;
                        } else {
                            errorMessage += ` - ${JSON.stringify(errorData)}`;
                        }
                    } else {
                        errorMessage += ` - ${axiosError.response.data}`;
                    }
                }
                throw new Error(errorMessage);
            } else if (axiosError.request) {
                throw new Error('エラー: サーバーからの応答がありません。');
            } else {
                throw new Error(`エラー: ${axiosError.message}`);
            }
        } else {
            throw new Error('予期せぬエラーが発生しました。');
        }
    }
};

// テストAPI
export const testApi = (data: any, token: string) => callApi('/chatbot/test', data, token);

// LLM API
export const llmApi = (data: any, token: string) => callApi('/chatbot/askLlm', data, token);

// RAG API
export const ragApi = (data: any, token: string) => callApi('/chatbot/askRag', data, token);

// AGENT API
export const agentApi = (data: any, token: string) => callApi('/chatbot/askAgent', data, token);

// 型定義
export interface ApiRequest {
    input: string;
    temperature?: number;
    max_tokens?: number;
    bedrock_model_id?: string;
    top_p?: number;
    sessionId?: string;
}

export interface ApiResponse {
    message?: string;
    answer?: string;
}